import { getCssSizeValue, getHtmlFromRedactorField, isStringEmpty } from "@/utils/utils"
import styled from "styled-components"
import Image, { formatImageCMSData } from "@/components/common/Image"
import { BREAKPOINTS } from "@/styles/themeSettings"
import { getLinkData } from "@/components/common/Links/utils"
import useHover from "@/hooks/useHover"
import UniversalLink from "@/components/common/Links/UniversalLink"

const StyledTile = styled(UniversalLink)`
	border: 1px solid ${({ theme }) => theme.colors.richBlack};
	margin-bottom: ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		border: unset;
		margin-bottom: ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(24)};
	}

	&.link {
		cursor: pointer;
	}
`

const StyledImageWrapper = styled.div`
	position: relative;
	aspect-ratio: 1;
	display: grid;
	place-items: center;
	overflow: hidden;

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		border: 1px solid ${({ theme }) => theme.colors.richBlack};
		border-bottom: unset;
	}

	&.full {
		border: none;
	}
`

const StyledImage = styled(Image)`
	aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || "16/9"};
	width: auto;
	transition: all var(--rgr-duration) var(--ease);
	height: ${getCssSizeValue(120, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
	}

	@media (min-width: ${({ theme }) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
		height: ${getCssSizeValue(200)};
	}

	&.full {
		height: auto;
		width: 100%;
	}

	&.hover {
		transform: scale(1.1);
	}
`

const StyledHeaderBar = styled.div`
	background: ${(props) => props.theme.colors.richBlue};
	color: ${(props) => props.theme.colors.antiflashWhite};
	padding: ${getCssSizeValue(10, BREAKPOINTS.MOBILE)} ${getCssSizeValue(16, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.tablet}px) {
		margin-bottom: ${getCssSizeValue(20, BREAKPOINTS.TABLET)};
		padding: ${getCssSizeValue(24, BREAKPOINTS.TABLET)} ${getCssSizeValue(32, BREAKPOINTS.TABLET)};
	}

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		margin-bottom: ${getCssSizeValue(16)};
		padding: ${getCssSizeValue(16)} ${getCssSizeValue(32)};
	}
`

const StyledDescription = styled.div`
	color: ${(props) => props.theme.colors.richBlack};
	padding: ${getCssSizeValue(24, BREAKPOINTS.MOBILE)};
	${getCssSizeValue(16, BREAKPOINTS.MOBILE)} ${getCssSizeValue(32, BREAKPOINTS.MOBILE)};

	@media (min-width: ${({ theme }) => theme.breakpoints.desktop || 1024}px) and (orientation: landscape) {
		padding: unset;
	}
`

export const COVER_SIZES = {
	SMALL: "small",
	FULL: "full",
}

function getData(data) {
	return {
		header: data?.header || "",
		description: data?.description || "",
		image: formatImageCMSData(data?.image || {}),
		link: getLinkData(data || {}),
		coverSize: data?.coverSize || COVER_SIZES.SMALL,
	}
}

export default function SingleTile({ item }) {
	const { header, description, image, link, coverSize } = getData(item)
	const linkExist = !isStringEmpty(link.url)
	const [ref, hovering] = useHover()
	const hoverClassName = hovering ? "hover" : ""

	return (
		<StyledTile
			className={`col-mobile-8 col-tablet-4 col-desktop-4 ${linkExist ? "link" : ""}`}
			ref={ref}
			external={link.isExternal}
			href={link.url}
			newCard={link.newCard}
			as={isStringEmpty(link.url) ? "div" : UniversalLink}
		>
			<div>
				<StyledImageWrapper className={coverSize === COVER_SIZES.FULL ? "full" : ""}>
					<StyledImage
						src={image.url}
						alt={image.alt}
						sizes={"100vw"}
						$aspectRatio={image.aspectRatio}
						className={`${coverSize === COVER_SIZES.FULL ? "full" : ""} ${hoverClassName}`}
					/>
				</StyledImageWrapper>
				<StyledHeaderBar className="typo-strawford typo-strawford-112">{header}</StyledHeaderBar>
				<StyledDescription
					className="typo-strawford typo-strawford-11"
					dangerouslySetInnerHTML={getHtmlFromRedactorField(description)}
				/>
			</div>
		</StyledTile>
	)
}
